module.exports = __webpack_public_path__ + "img/email-notification-icon.48494430.png";